import Uplot from './Uplot';

export default Uplot;
